"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaGuardianInviteFactory = void 0;
const Factory = require("factory.ts");
const guardian_invite_user_factory_1 = require("./guardian-invite-user.factory");
const guardian_invite_persona_factory_1 = require("./guardian-invite-persona.factory");
const user = guardian_invite_user_factory_1.guardianInviteUserFactory.build();
const persona = guardian_invite_persona_factory_1.guardianInvitePersonaFactory.build();
exports.personaGuardianInviteFactory = Factory.Sync.makeFactory({
    id: `persona-guardian-invite-${Factory.each(i => i + 1)}`,
    user_id: user.id,
    persona_id: persona.id,
    access: 'viewer',
    persona_listener_id: null,
    email_address: user.email_address,
    user,
});
